module.exports = __webpack_public_path__ + "img/thinking_panda2.4ee71ad2.gif";